import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { IReadView, IReadViewRawData, IReadViewRawDataWrapper } from '../interfaces/schema.interface';
@Injectable({
  providedIn: 'root'
})
export class SchemaService {
  linkData: any = { key:'', text:'', link:''};
  urlProcessVariable = 'businessKeyViewUrl';
  ignoreKeys = ['bkey','baseurl','bpmnid','clminterface','clminterfacedate','body','searchuri','xuserid','${submittedby}','orgid',
          'teamallocation', 'autoapproval','id','endcustomer','end customer','cadidategroup','templatename','statuscode','cc','to',
          'operation','functioncode','condition','timer','requestid','enquiryid','equiryid','referenceid','riskassresult','refrenceno',
          'subject', '${sender.identifier}', 'goodsentryid', 'goodsexitid', 'declarationid' , 'autoapprove' , 'paymentskip' , 'exportercode',
           'importercode' , 'identifier' , 'regime' ,'businessKey' , 'insCaseDetailsId', 'pcaAuditType', 'documentVerification', 'bearerToken'];
  replaceKeys = ['${submittedby}', 'action', 'actionby', '{submittedby}', 'userid'];

  constructor() {}

  /**
   * Convert => IReadViewRawDataWrapper | {"aTaskVariableKey":{"value":{"property1":"aPropertyValue","property2":true},"type":"ExampleVariableObject"}}
   * To => IReadView[]
   * @param data : Task variable
   */
  convertToReadView(data : IReadViewRawDataWrapper, objectKeys: string[]): IReadView[]{
    let readViewData: IReadView[] = [];
    if(!_.isEmpty(objectKeys)){
      readViewData = this.convertObjectPropToReadView(data, objectKeys);
    }else{
      readViewData = this.convertTaskVariables(data);
    }
    return readViewData;
  }

  convertVariableInstanceToReadView(data: any[]){
    let readViewData: IReadView[] = [];
    let localIgnoreKeys = this.ignoreKeys;
    let linkObj: IReadView = {key:'Request',text:''};
    localIgnoreKeys = localIgnoreKeys.concat(['businesskeyviewurl','comments','action']);
    data.forEach((d)=>{
      if(d.name === 'businessKeyIdentifier'){
        linkObj.text = d.value;
      }else if(d.name === 'businessKeyViewUrl'){
        linkObj.link = (window.location.href.indexOf('admin-ui') != -1 ? '/admin-ui' : '') + '/#' + d.value + '?isDialog=true';
      }else if(localIgnoreKeys.indexOf(d.name?.toLowerCase()) === -1 &&
      typeof d.value === 'string'){
        readViewData.push({key: d.name,text: d.value});
      }
    });
    if(linkObj.link){
      readViewData.unshift(linkObj);
    }
    return readViewData;
  }

  getAttachmentsFromVariableInstance(data: any[]){
    let files:any[] = [];
    data.forEach((d)=>{
      if(d.name === 'attachments' &&
      Array.isArray(d.value)){
        files = files.concat(d.value);
      }
    });
    return files;
  }

  /**
   * Generate array of `IReadView` from `IReadViewRawDataWrapper`
   * @param data
   */
  private convertTaskVariables(data : IReadViewRawDataWrapper): IReadView[]{
    let readViewData: IReadView[] = [];
    this.linkData.text = '';
    _.forEach(data, (value, key) =>{
      if(typeof value.value === 'object'){
        _.forEach(value.value, (valueV, keyV)=>{
          if(typeof value.value[keyV] === 'object' || (this.ignoreKeys.indexOf(keyV.toString().toLowerCase() || "")>-1)) return;
          if(typeof value.value[keyV] === 'object' || (this.replaceKeys.indexOf(keyV.toString().toLowerCase() || "")>-1)) keyV = this.mapKey(keyV.toString().toLowerCase());
          let data = this.mapObject(null,keyV,value.value);
          if(data && _.findIndex(readViewData, data) == -1){
            readViewData.push(data);
          }
        });
      }else{
        if(typeof value.value === 'object' || this.ignoreKeys.indexOf(key.toString().toLowerCase() || "")>-1) return;
        if(typeof value.value === 'object' || this.replaceKeys.indexOf(key.toString().toLowerCase() || "")>-1) key = this.mapKey(key.toString().toLowerCase());
        let data = this.mapObject(key,null,value.value)
        if(data && _.findIndex(readViewData, data) == -1)
          readViewData.push(data);
      }

    });
    if(this.linkData.text.length > 0)
      readViewData.unshift(this.linkData);
    return _.reject(readViewData,function(data){return _.isEmpty(data.key)});
  }

  private mapKey(key:any):any{
    switch(key){
      case '${submittedby}':
        return 'Submitted By';
    }
  }
  private mapObject(key:any, keyV:any, objectVal:any){
    let links = ['aeoRequestNumber', 'requestNo', 'refrenceNo', 'declarationNumber', 'businessKeyIdentifier', 'licenseNo','lpcoIdentifier', 'profileCode'];
    if(keyV){
      if(links.indexOf(keyV) >= 0){
        this.linkData.key = keyV;
        this.linkData.text = objectVal[keyV];
        return undefined;
      } else {
        if(keyV === this.urlProcessVariable){
          this.linkData.link = (window.location.href.indexOf('admin-ui') != -1 ? '/admin-ui' : '') + '/#' + objectVal[keyV] + '?isDialog=true';
          return undefined;
        } else {
          return{ key: keyV, text: objectVal[keyV]};
        }
      }
    } else {
      if(links.indexOf(key) >= 0){
        this.linkData.key = key;
        this.linkData.text = objectVal;
        return undefined;
      } else {
        if(key === this.urlProcessVariable){
          this.linkData.link = (window.location.href.indexOf('admin-ui') != -1 ? '/admin-ui' : '') + '/#' + objectVal + '?isDialog=true';
          return undefined;
        } else {
          return { key: key, text: objectVal};
        }
      }
    }
  }

  /**
   * Generate array of `IReadView` for specific properties `objectKeys`
   * @param data : Object | BpsTask
   * @param objectKeys
   */
  private convertObjectPropToReadView(data: IReadViewRawData | any, objectKeys: string[]): IReadView[]{
    let readViewData: IReadView[] = [];
    _.forEach(objectKeys,function(key){
      readViewData.push({ key: key, text: data[key]})
    });
    return readViewData;
  }
}
